import service from "@/utils/request";
import * as apiRequest from "@/api/Type";
const url = require("@/utils/data").url;

/**
 * 根据项目ID获取文章列表
 * @param data {apiRequest.QueryArticleList}
 */
export const queryArticleList = (data: apiRequest.QueryArticleList) => {
    return service({
        url: url + "/article/query/list",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 添加文章
 * @param data {apiRequest.AddArticle}
 */
export const addArticle = (data: apiRequest.AddArticle) => {
    return service({
        url: url + "/article/add",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 修改文章
 * @param data {apiRequest.ModifyArticle}
 */
export const modifyArticle = (data: apiRequest.ModifyArticle) => {
    return service({
        url: url + "/article/modify",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 删除文章
 * @param data {apiRequest.DelArticle}
 */
export const delArticle = (data: apiRequest.DelArticle) => {
    return service({
        url: url + "/article/del",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 获取文章详情
 * @param data {apiRequest.QueryArticleInfo}
 */
export const queryArticleInfo = (data: apiRequest.QueryArticleInfo) => {
    return service({
        url: url + "/article/query/info",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}
